import formatDateInput from "./formataDateInput"
import moment from "moment"

export function getMenusByDate(
  currentDate,
  allMenus,
  selectedFoodType = null,
  selectedRestaurant = null
) {
  let selection = []
  selection = allMenus.reduce(function (filtered, restaurant) {
    if (restaurant.restaurantACF.ongoinMenus === null) {
      restaurant.restaurantACF.ongoinMenus = []
    } else {
      restaurant.restaurantACF.ongoinMenus = restaurant.restaurantACF.ongoinMenus.filter(
        menu => {
          if (menu.date !== null) {
            let formattedInputDate = ""
            formattedInputDate = formatDateInput(menu.date)
            return currentDate.isSame(formattedInputDate, "day")
          }
          let isbefore = false
          let isAfter = false
          isbefore = currentDate.isSameOrBefore(
            formatDateInput(menu.dateDeFin),
            "day"
          )
          isAfter = currentDate.isSameOrAfter(
            formatDateInput(menu.dateDeDebut),
            "day"
          )

          return isbefore && isAfter
        }
      )
    }

    if (restaurant.restaurantACF.ongoinMenus.length > 0) {
      filtered.push(restaurant)
    }

    if (selectedFoodType !== null && selectedFoodType !== "") {
      filtered = filtered.filter(function (restaurant) {
        let match = false
        restaurant.allFoodTypessMetadata.nodes.forEach(element => {
          if (selectedFoodType === element.slug) {
            match = true
            return
          }
        })
        return match
      })
    }
    if (selectedRestaurant !== null && selectedRestaurant !== "") {
      filtered = filtered.filter(function (restaurant) {
        return (
          restaurant.title
            .toLowerCase()
            .includes(selectedRestaurant.toLowerCase()) ||
          selectedRestaurant
            .toLowerCase()
            .includes(restaurant.title.toLowerCase())
        )
      })
    }
    return filtered
  }, [])

  return selection
}

export function getMenu(restaurantACF) {
  const currentDate = moment()
  let currentMenu = []
  if (restaurantACF.ongoinMenus && restaurantACF.ongoinMenus === !null) {
    currentMenu = restaurantACF.ongoinMenus.filter(function (menu) {
      if (menu.date !== null) {
        let formattedInputDate = ""
        formattedInputDate = formatDateInput(menu.date)
        return currentDate.isSame(formattedInputDate, "day")
      } else {
        let isbefore = false
        let isAfter = false
        isbefore = currentDate.isSameOrBefore(
          formatDateInput(menu.dateDeFin),
          "day"
        )
        isAfter = currentDate.isSameOrAfter(
          formatDateInput(menu.dateDeDebut),
          "day"
        )
        return isbefore && isAfter
      }
    })
  }

  if (currentMenu.length === 0) {
    currentMenu = restaurantACF.ongoinMenus
  }
  restaurantACF.ongoinMenus = currentMenu
  return restaurantACF
}
